// https://github.com/lcdsantos/jQuery-Selectric

import 'selectric/src/jquery.selectric';
import redirect from 'v1/utils/redirect';

const customSelect = function($container) {
  const container = $container || $('body');
  const $select = container.find($('@customSelect'));

  const init = () => {
    const settings = {
      maxHeight: 300,
      disableOnMobile: false,
    };
    $select.selectric(settings);
    $select.selectric().on('change', function() {
      redirect($(this).val());
    });
  };

  if ($select.length > 0) {
    init();
  }
};

export default customSelect;
